import { ApiProperty } from "@nestjs/swagger";
import { MeasurementDataDTO } from "./measurement-dto";
import { TrimCardStatusEnum } from "@project-management-system/shared-models";

export class StylesDto {
    @ApiProperty()
    id: number

    @ApiProperty()
    dropDown: string

    @ApiProperty()
    styleData: string

    @ApiProperty()
    seasonData: string

    @ApiProperty()
    submitDate: string

    @ApiProperty()
    styleDescription: string

    @ApiProperty()
    techPack: string

    @ApiProperty()
    stateData: string

    @ApiProperty()
    status: TrimCardStatusEnum
    
    @ApiProperty()
    color: string

    @ApiProperty({ type: [MeasurementDataDTO] })
    measurementchartData: MeasurementDataDTO[];

    combinedProductPlusColor: {
        combinedFabricColorHeaders: string[];
        combinedLabelColorHeaders: string[];
        combinedPackingColorHeaders: string[];
        combinedTrimColorHeaders : string[];
    }

    combinedColumbiaPlusColor: {
        combinedColumbiaFabricHeaders:string[];
        combinedColumbiaSewingHeaders:string[];
        combinedColumbiaPackingHeaders:string[];
        combinedColumbiaEmbellishmentHeaders:string[];
        stylesFinalDataColumbia
    }

    combinedCKPlusColor: {
        combinedCKFabricAndLiningColorHeaders: string[];
        combinedCKZippersColorHeaders: string[];
        combinedCKTrimsColorHeaders: string[];
    }

}
